import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import { AppConfig } from '../../core/app/app.config';


export class DTM extends MsgHandler {
  private static _self: DTM = null;

  private constructor() {
    super(consts.MSG_TYPE_DTM_HEIGHT);
  }

  public static getSelf(): DTM {
    if (this._self == null)
      this._self = new DTM();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("dtm msg:", msgObj);
    localStorage.setItem(consts.LOCAL_STORAGE_HEIGHT_KEY, msgObj.LocationAltitude);
  }
}
